import { motion } from 'framer-motion'
import React from 'react'
import { useDispatch } from 'react-redux'
import {
    setModalContent,
    showModal,
} from '../../../store/reducers/ModalReducer'
import Button from '../../Button/Button'
import Section from '../../Section/Section'
import CSS from './Whoami.module.css'

function Whoami() {
    const dispatch = useDispatch()
    return (
        <div className={CSS.container}>
            <div className={CSS.left}>
                <div className={CSS.title}>So,who am i?</div>
                <div className={CSS.text}>
                    <div>
                        My name is Demba Diack, born 1998 in nouakchott,future
                        CS graduate at one of the top unis in Dakar
                    </div>
                    <div>
                        I love to solve complex problems as simply and
                        effectivly as possible.
                    </div>
                </div>
                <div
                    className={CSS.link}
                    onClick={(e) => {
                        dispatch(
                            setModalContent(
                                <div style={{textAlign : "center"}}>
                                    <div
                                        style={{
                                            fontSize: '5vmin',
                                        }}
                                    >
                                        More about me
                                    </div>
                                    <div>Born in Nouakchott,Mauritania, when i was a kid i loved two things, drawing and computers <br/></div>
                                    <div>when kids were going out playing soccer , i stayed home sketching around, or installing new software like blender 3d, photoshop,zbrush etc to learn something new</div>
                                    <div>one thing i regret is not having installed vscode sooner than college! man would i be a genius by now</div>
                                    <div>but dont let that fool you, i have made sure i cought up, i am confident in my skills and my abality to learn quickly has even surprised me.</div>
                                </div>
                            )
                        )
                        dispatch(showModal())
                    }}
                >
                    <Button name="More" url="#" />
                </div>
            </div>
            <div className={CSS.right}>
                <motion.div
                    initial={{
                        scale: 0,
                    }}
                    animate={{
                        rotate: 360,
                        scale: 1,
                    }}
                    transition={{
                        type: 'spring',
                        stiffness: 260,
                        damping: 20,
                    }}
                    className={CSS.image}
                ></motion.div>
            </div>
        </div>
    )
}

export default Whoami
